import resume from '../assets/pdf/PraveenKumarSuthar_FullStackLead.pdf'

export const headerData = {
    name: 'Praveen Kumar Suthar',
    title: "ENGINEERING LEAD | AI ENGINEERING | FULL STACK | TEAM DEVELOPMENT",
    desciption:"I am an Engineering Lead bridging the gap between highly scalable enterprise architecture and the AI frontier. With a decade of experience building robust e-commerce systems, I now focus on AI Engineering—developing autonomous agents, MCP integrations, and intelligent developer tooling. In the AI era, let's build software that doesn't just scale, but thinks.",
    resumePdf: resume
}
